import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityTemplateOverrideRemoveFailedAction = {
	type: 'FACILITY_TEMPLATE_OVERRIDE_REMOVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityTemplateOverrideRemoveFailedAction => ({
	type: 'FACILITY_TEMPLATE_OVERRIDE_REMOVE_FAILED',
	payload,
});
